module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAmCAMAAAAcJyCnAAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAlqU4oYxDEAkF5OHa1YWEgmxLPTJrSBaRAAAAVUlEQVQoz83QuQ3AMAxDUfqQ7dwn9181A4hdkMC/fFAhEF80xEvoTvOYyOCwzUo3Ko0daJZ6T0pRs1LgTGLIo8K3cvS3SX/WwTr/qkltgTT4ylLwugecrgdXYDrsFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progressPage/num-1.png
// module id = u3I4
// module chunks = 1